import { Injectable, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { concatMap, tap } from "rxjs/operators";
import { IotModel } from "app/shared/models/iot.model";
import { MedicationIncidentTopicNames } from "app/shared/models/iot.topics";
import { MedicationActions, PubsubModel } from "app/shared";

import { FoundMedicationIncidentModel } from "./found-medication-incident-model.service";

@Injectable()
export class FoundMedicationIncidentListener extends PubsubModel {
	private readonly iotModel = inject(IotModel);
	private readonly store = inject(Store);
	private readonly foundMedicationIncidentModel = inject(FoundMedicationIncidentModel);

	override listen() {
		return this.syncCreateFoundMedicationIncident().subscribe();
	}

	private syncCreateFoundMedicationIncident() {
		return this.iotModel
			.subscribeWithOrganisationPrefix<{ id: string }>(MedicationIncidentTopicNames.FOUND_MEDICATION_INCIDENT_CREATED)
			.pipe(
				concatMap((medicationIncidentData) =>
					this.foundMedicationIncidentModel.getFoundMedicationIncident(medicationIncidentData.id),
				),
				tap((medicationIncident) => {
					this.store.dispatch(MedicationActions.createFoundMedicationIncidentIot(medicationIncident));
				}),
			);
	}
}
